import Vue from 'vue'
import Router from 'vue-router'

import Login from "../components/Login";
import LoginLink from "../components/LoginLink";
import AdminUser from "../components/main/adminUser/AdminUser";
import OTA from "../components/main/ota/OTA";
import Devices from "../components/main/device/Devices";
import Crafties from "../components/main/crafties/Crafties";
import Statis from "../components/main/Statis";
import ProductionManage from "../components/main/productionManage/ProductionManage";
import CraftiesContent from "../components/main/crafties/CraftiesContent";
import AppVersion from '../components/main/appVersion/AppVersion'
import DeviceAudioVersion from '../components/main/deviceAudio/DeviceAudioVersion'
import Bluetooth from '../components/main/bluetooth/Bluetooth'
import CraftieIDWrite from '../components/main/craftieIdWrite/CraftieIDWrite'
import WhiteNoise from '../components/main/whitenoise/WhiteNoise'
import VersionManage from '../components/main/versionManage/index'
import EmailTemplate from '../components/main/emailTemplate/EmailTemplate'
import Statistics from '../components/main/statistics/Statistics'
import CraftieQA from '../components/main/craftieQA/CraftieQA'
import Warning from '../components/main/warning/WarnManage'
import DataExport from '../components/main/export/DataExport'
import CraftieSearch from '../components/main/craftieSearch/CraftieSearch'
import ProductSearch from '../components/main/craftieSearch/ProductSearch'
import IcraftieDataManage from '../components/main/icraftieDataManage/IcraftieDataManage'

const util = require("../util/util").default;
import ElementUI from 'element-ui';

Vue.use(Router)
const routers = [
  {
    path: '/',
    redirect: '/crafties',
    meta: {
      roles: null,
    }
  }, {
    name: 'login',
    path: '/login',
    component:Login,
    meta: {
      roles: null,
    }
  },{
    name: 'loginlink',
    path: '/loginlink',
    component: LoginLink,
    meta: {
      roles: null,
    }
  },{
    name: "crafties",
    path: '/crafties',
    component: Crafties,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'craftiesContent',
    path: '/crafties/content',
    component: CraftiesContent,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'Devices',
    path: '/devices',
    component: Devices,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'adminUser',
    path: '/adminUser',
    component: AdminUser,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'ota',
    path: '/ota',
    component: OTA,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'statis',
    path: '/statis',
    component: Statis,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'productionManage',
    path: '/production',
    component: ProductionManage,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'appVersion',
    path: '/appVersion',
    component: AppVersion,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'bluetooth',
    path: '/bluetooth',
    component: Bluetooth,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'deviceAudioVersion',
    path: '/deviceAudioVersion',
    component: DeviceAudioVersion,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'craftieIDWrite',
    path: '/craftieIDWrite',
    component: CraftieIDWrite,
    meta: {
      roles: ['admin'],
    }
  }, {
    name: 'whiteNoise',
    path: '/whiteNoise',
    component:WhiteNoise,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'versionManage',
    path: '/versionManage',
    component: VersionManage,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'emailTemplate',
    path: '/emailTemplate',
    component: EmailTemplate,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'statistics',
    path: '/statistics',
    component: Statistics,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'craftieqa',
    path: '/craftieqa',
    component: CraftieQA,
    meta: {
      roles: ['admin'],
    }
  },{
    name: 'warning',
    path: '/warning',
    component: Warning,
    meta: {
      roles: ['admin'],
    }
  },
  {
    name:'export',
    path:'/export',
    component:DataExport,
    meta: {
      roles: ['admin'],
    }
  },
  {
    name:'craftieSearch',
    path:'/craftieSearch',
    component:CraftieSearch,
    meta: {
      roles: ['admin'],
    }
  },
  {
    name: 'productSearch',
    path: '/craftieSearch/product',
    component: ProductSearch,
    meta: {
      roles: ['admin'],
    }
  },
  {
    name: 'icraftieDataManage',
    path: '/icraftieDataManage',
    component: IcraftieDataManage,
    meta: {
      roles: ['admin'],
    }
  },
]
const router = new Router({
  mode:'history',
  routes: routers
})
//重复点击导航栏报错解决
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 全局前置守卫
router.beforeEach((to, from, next) => {
  const toPath = to.path

  const index = routers.findIndex(item => item.path === toPath)
  if (index === -1) {
    ElementUI.Message.error('Wrong path!')
    return next({path:from.path})
  }
  const roles = routers[index].meta.roles
  if (roles != null && !roles.includes(util.getRole())) {
    next({path: "/login"})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js